import React from 'react';
import Footer from './Footer';
import Navbar from './Navbar1';

function Playdateaggrement() {
    return (
        <div>
            <Navbar />
                <div className="max-w-4xl mx-auto px-4 py-8 text-black">
                    <div className="text-start ">
                        <h1 className="text-2xl font-bold">PAWFECT INTERACTION AGREEMENT</h1>
                    </div>

                    <div className="text-lg mt-8 space-y-6">
                        <p>Welcome to PAWFECT! Before registering for an interaction through this application, please carefully read and agree to the following terms and conditions:</p>

                        <div>
                        <h3 className="font-semibold text-lg">1. Responsibilities and Guidelines:</h3>
                        <p className="mt-2">
                            By using PAWFECT, you acknowledge and agree to the following responsibilities:
                        </p>
                        <ul className="list-disc pl-6 mt-4 space-y-4">
                            <li>
                            <span className="font-semibold">Vaccinations Responsibility:</span> You certify that your pet's vaccinations are up-to-date in compliance with local regulations and ethical standards, including those promoted by organizations like PETA. Ensure your pet's vaccinations are current before engaging in any interactions facilitated by this application.
                            </li>
                            <li>
                            <span className="font-semibold">Owner's Responsibility:</span> You are solely responsiblfe for your pet's behavior, health, and actions during meetups or mating facilitated through PAWFECT. The application and its company are not liable for any incidents or issues arising from these interactions.
                            </li>
                            <li>
                            <span className="font-semibold">Genetic Verification:</span> Verify your pet's genetics and health history before engaging in any mating activities through this application. PAWFECT does not verify or guarantee the genetic background of pets on the platform.
                            </li>
                        </ul>
                        </div>

                        <div>
                        <h3 className="font-semibold text-lg">2. Additional Points:</h3>
                        <ul className="list-disc pl-6 mt-4 space-y-4">
                            <li>
                            <span className="font-semibold">Health Check Responsibility:</span> Prioritize your pet's health by ensuring they are in good health before participating in any interactions facilitated by PAWFECT. Consult a veterinarian for any health concerns.
                            </li>
                            <li>
                            <span className="font-semibold">Behavioral Assessment:</span> Ensure your pet has a history of good behavior and socialization to minimize conflicts or incidents during interactions.
                            </li>
                            <li>
                            <span className="font-semibold">Emergency Situations:</span> Seek immediate veterinary assistance in case of emergencies during interactions facilitated by PAWFECT. PAWFECT is not liable for emergencies or disputes that may arise.
                            </li>
                            <li>
                            <span className="font-semibold">Legal Compliance:</span> Abide by local laws governing pet ownership, interactions, and mating in your area while using PAWFECT.
                            </li>
                            <li>
                            <span className="font-semibold">Communication and Transparency:</span> Transparently share relevant information about your pet's health, behavior, and history with other users for a safe interaction experience.
                            </li>
                            <li>
                            <span className="font-semibold">Feedback and Reporting:</span> Provide feedback on your experiences and report any inappropriate behavior or activities observed to PAWFECT for review and action.
                            </li>
                        </ul>
                        </div>

                        <div>
                        <h3 className="font-semibold text-lg">3. Privacy Considerations:</h3>
                        <ul className="list-disc pl-6 mt-4 space-y-4">
                            <li>
                            <span className="font-semibold">Data Protection and Privacy:</span> By using PAWFECT, you agree to the collection, storage, and processing of your data as outlined in the Privacy Policy.
                            </li>
                            <li>
                            <span className="font-semibold">Sharing of Information:</span> Certain user information may be shared to facilitate interactions on the platform which may include images, videos, text and voice messages, visual represntation and any other forms of visual or multimedia content. Such information is shared for the purposes of communication, collaboration, content display, or functionality as intended within the scope of the APP. The APP may also use this shared content to improve user experience, subject to applicable privacy settings and data protection laws. Sensitive personal information will not be shared without explicit consent.
                            </li>
                            <li>
                            <span className="font-semibold">Third-Party Services:</span> PAWFECT may utilize third-party services with their own privacy policies. PAWFECT is not responsible for the practices of these external entities.
                            </li>
                            <li>
                            <span className="font-semibold">Security Measures:</span> While PAWFECT implements security measures, users should take precautions as no data transmission over the internet is entirely secure.
                            </li>
                            <li>
                            <span className="font-semibold">Data Retention:</span> PAWFECT may retain user data for a reasonable period as required by law.
                            </li>
                            <li>
                            <span className="font-semibold">Opt-out and Account Deletion:</span> Users have the option to modify, update, or delete their account and personal information.
                            </li>
                        </ul>
                        </div>

                        <div>
                        <h3 className="font-semibold text-lg">4. Indemnification:</h3>
                        <p className="mt-2">
                            You agree to indemnify and hold PAWFECT, the Company and its affiliates, officers, employees, agents, and partners harmless from and against any claims, liabilities, damages, losses, and expenses arising out of or in connection with your use of PAWFECT or any breach of this Agreement.
                        </p>
                        </div>

                        <p className="font-semibold mt-6">
                            By clicking "Agree," you acknowledge that you have read, understood, and agreed to abide by the terms and conditions outlined in this End-User Agreement and the accompanying Privacy Policy.
                        </p>
                    </div>
                </div>
            <Footer />
        </div>

    );
}

export default Playdateaggrement;
